<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap v-if="!currentModel" >
      <v-flex xs12>
       <v-card  style="border-radius: 0;">
        <v-card-text class="text-xs-center">
          <v-progress-circular :width="6" :size="60" indeterminate color="primary"></v-progress-circular>
        </v-card-text>
      </v-card>
      </v-flex>
    </v-layout>
    <v-layout v-else row wrap>
      <v-flex xs12>
       <v-card  style="border-radius: 0;">
        <v-card-title>
          <v-spacer></v-spacer>
          <h2>{{currentModel.name}}</h2>
          <v-spacer></v-spacer>
        </v-card-title>
      </v-card>
      </v-flex>
      <v-flex xs2>
        <v-card>
          <v-list class="mt-0 pt-0">
            <v-card color="primary" dark style="border-radius: 0;">
              <v-toolbar card color="primary" dark dense>
                <v-spacer></v-spacer>
                <v-toolbar-title >{{$t('gameVersions.menu')}}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </v-card>
            <v-divider></v-divider>
            <v-list-tile :to="'/game-versions/' + $route.params.id + '/companies'">
              <v-list-tile-title >Maillons</v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="'/game-versions/' + $route.params.id + '/params'">
              <v-list-tile-title >Paramètres</v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="'/game-versions/' + $route.params.id + '/style'">
              <v-list-tile-title >Style</v-list-tile-title>
            </v-list-tile>
            <v-list-tile :to="'/game-versions/' + $route.params.id + '/graph'">
              <v-list-tile-title >{{$t('inGame.supplychainGraph')}}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs10>
        <v-slide-y-transition mode="out-in">
          <router-view :key="$route.params.id_company" />
        </v-slide-y-transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "GameVersion",
  components: {},
  data() {
    return {
      currentModel: null
    }
  },
  async mounted() {
    this.currentModel = null
    let model = await this.$store.dispatch("gameVersions/getOne", this.$route.params.id);
    this.currentModel = Object.assign({}, model);
  },
  methods: {},
  computed: {}
};
</script>
